<template>
    <article class="article-wrapper article3 fade10"
    :class="{'active': $parent.isfadeInActive && $parent.isfadeInA3,
        'line-bg1':targetIdx===0,
        'line-bg2':targetIdx===1,
        'line-bg3':targetIdx===2}">
        <h2 class="title fade10" :class="{'active': $parent.isfadeInActive && $parent.isfadeInA3}"
        v-text="data.title">本月作文佳作發表</h2>
        <div class="info-wrapper fade11"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA3}">
            <p class="source">
                【發布單位／{{data.title_unit}}】
                <a href="" title="FB分享" class="fb-btn"
                @click.prevent="$parent.onShare('fb', data.share_link);
                gaEvent('share_fb', 'essay_sharefb');">
                    <img src="@/assets/images/btn_article_fb_n@3x.png" />
                </a>
                <a href="" title="Line分享" class="line-btn"
                @click.prevent="$parent.onShare('line', data.share_link_line, data.line_text);
                gaEvent('share_line', 'essay_shareline');">
                    <img src="@/assets/images/btn_article_line_n@3x.png" />
                </a>
            </p>
        </div>
        <div class="photo-wrapper fade12"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA3}">
            <img :src="data.image_path"
            class="photo"
            v-if="data.image_path" />
        </div>
    </article>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'article3',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    title_unit: '',
                    image_path: '',
                    share_link: '',
                };
            },
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
        };
    },
    mounted() {
    },
    methods: {
    },
    mixins: [mixinMethod],
};
</script>
